(function () {
  function cleanRecentlyViewed() {
    document.querySelectorAll(".recently-viewed-wrapper").forEach(function (wrapper) {
      wrapper.querySelectorAll(".predictive-search-results__card").forEach(function (card) {
        var productCard = card.querySelector("product-card-link");
        var link = card.querySelector(".resource-card__link");

        var hasProductId = productCard && productCard.dataset.productId;
        var hasProductLink = link && link.getAttribute("href");

        if (!hasProductId || !hasProductLink) {
          card.remove();
        }
      });

      var remainingCards = wrapper.querySelectorAll(".predictive-search-results__card");

      if (remainingCards.length === 0) {
        wrapper.remove();
      }
    });
  }

  cleanRecentlyViewed();

  new MutationObserver(cleanRecentlyViewed).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();